.wrapper {
  flex-direction: column;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}

gz-image-repo {
  padding: calc(var(--spacer) * 10);
}

gz-grid-view {
  padding-top: calc(var(--spacer) * 2);
}

#not-started {
  height: 100%;
}

#no-results {
  height: 100%;
}

#in-progress {
  height: 100%;
}
